import React from 'react'
import {Box, Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import {BrandLogo} from '../../../components/icons'
import {HOME_HREF} from '@salesforce/retail-react-app/app/constants'

const CustomHeader = () => {
    return (
        <Box
            px={[4, 4, 8]}
            bgColor="headerBgColor"
            color={'white'}
            borderBottom="1px"
            borderColor="gray.100"
        >
            <Box maxWidth="container.xxxl" marginLeft="auto" marginRight="auto">
                <Flex
                    h={{base: '52px', md: '80px'}}
                    align="center"
                    justify="space-between"
                    className="white-color"
                >
                    <Link href={HOME_HREF} title="Back to homepage" p={2}>
                        <BrandLogo
                            width={{base: '35px', md: '45px'}}
                            height={{base: '24px', md: '32px'}}
                        />
                    </Link>
                </Flex>
            </Box>
        </Box>
    )
}

export default CustomHeader
